import FAQ from './FAQ';

function RenovatieFAQ() {
  const faqs = [
    {
      question: 'Hoe lang duurt een elektrarenovatie gemiddeld?',
      answer: 'Een gemiddelde elektrarenovatie duurt 3-5 werkdagen, afhankelijk van de omvang van het project. Bij grotere renovaties kan dit oplopen tot 1-2 weken. We maken vooraf een duidelijke planning en zorgen dat u aan het einde van elke werkdag weer stroom heeft.'
    },
    {
      question: 'Kan ik tijdens de renovatie in mijn huis blijven wonen?',
      answer: 'Ja, in de meeste gevallen kunt u gewoon in uw huis blijven wonen tijdens de renovatie. We werken in fases en zorgen dat u aan het einde van elke werkdag weer stroom heeft. Voor grote renovaties maken we een planning die bij uw situatie past.'
    },
    {
      question: 'Wat zijn de kosten van een elektrarenovatie?',
      answer: 'De kosten variëren afhankelijk van de omvang van het project en de staat van uw huidige installatie. Een gemiddelde renovatie ligt tussen €2.500 en €7.500. We maken altijd eerst een gratis inspectie en stellen dan een gedetailleerde offerte op.'
    },
    {
      question: 'Is een elektrarenovatie nodig bij een oude woning?',
      answer: 'Bij woningen ouder dan 30-40 jaar is een elektrarenovatie vaak aan te raden. Oude installaties voldoen meestal niet meer aan de huidige veiligheidseisen en zijn vaak niet berekend op modern stroomverbruik met apparaten als inductiekookplaten en laadpalen.'
    },
    {
      question: 'Welke garantie krijg ik op de renovatie?',
      answer: 'We geven 2 jaar garantie op al onze installatiewerkzaamheden. Daarnaast gelden de fabrieksgaranties op de gebruikte materialen. Bij elk project leveren we een keuringsrapport volgens de NEN 1010 normen.'
    }
  ];

  return <FAQ title="Veelgestelde vragen over elektrarenovatie" faqs={faqs} />;
}

export default RenovatieFAQ;